import { forwardRef, ComponentPropsWithoutRef } from "react"
import { Text } from ".."

export const CardContent = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<"div">>(
  ({ children, className = "", ...rest }, ref) => {
    const _children = typeof children === "string" ? <Text>{children}</Text> : children

    return (
      <div ref={ref} className={className} {...rest}>
        {_children}
      </div>
    )
  },
)

CardContent.displayName = "Card.Content"
